export function getToken() {
  return localStorage.getItem('token');
}
export function getUserRole() {
  const user = JSON.parse(localStorage.getItem('userData'));
  return user?.role;
}
